import { useEffect, useState } from "react";
import Link from "next/link";
import styles from "./buttonBgAnimate.module.scss";
import { appendAttributionBridgeParams } from "@/lib/dashboard-urls";

const ButtonBgAnimate = ({
  title,
  url,
  outline,
  light = false,
  target = "",
  onClick = () => {},
}) => {
  const [href, setHref] = useState(url || "/");

  useEffect(() => {
    if (!url) {
      setHref("/");
      return;
    }
    setHref(appendAttributionBridgeParams(url));
  }, [url]);

  return (
    <div
      className={`${styles["buttonBgAnimate"]} ${
        outline ? styles["outline"] : ""
      } ${light ? styles["light"] : ""}`}
    >
      {url ? (
        <Link href={href} prefetch={false} target={target} onClick={onClick}>
          {title}
        </Link>
      ) : (
        onClick && <button onClick={onClick}>{title}</button>
      )}
    </div>
  );
};

export default ButtonBgAnimate;
